import {
  set as setActiveCountries,
  toggleSend as toggleSendActiveCountries,
} from "shared/redux/slices/location/activeCountries";
import {
  set as setCity,
  toggleSend as toggleSendCity,
} from "shared/redux/slices/location/city";
import {
  set as setCountries,
  toggleSend as toggleSendCountries,
} from "shared/redux/slices/location/country";

import {
  getActiveCountries,
  getCities,
  getCity,
  getCountries,
} from "shared/services/location";

/**
 * Request and set to redux user location data
 * @param {function} dispatch Dispatch function for redux
 * @param {string} country Country ISO2 code
 * @param {null|number} city City id
 */
export const initFirstTimeCities = (dispatch, country, city = null) => {
  if (!city) {
    dispatch(setCity({ city: [], country: country }));
  } else {
    dispatch(toggleSendCity(true));
    getCity(country, city)
      .then(({ data }) => {
        if (!data.success) {
          return false;
        }

        dispatch(setCity({ city: data?.data ?? [], country: country }));
      })
      .catch((error) => {
        console.error(error.toString());
      })
      .finally(() => {
        dispatch(toggleSendCity(false));
      });
  }
};

/**
 * Request and set to redux user location data
 */
export const getCountriesList = () => {
  return (dispatch) => {
    dispatch(toggleSendCountries(true));
    getCountries()
      .then(({ data }) => {
        if (!data.success) {
          return false;
        }
        dispatch(setCountries(data?.data));
      })
      .catch((error) => {
        console.error(error.toString());
      })
      .finally(() => {
        dispatch(toggleSendCountries(false));
      });
  };
};

/**
 * Get counties by api
 * @param {string} country Country ISO2 code
 * @param {string} city City name
 * @param {function} cbSuccess Success callback function
 * @param {function} cbFailed Failed callback function
 */
export function getCitiesList(country, city, cbSuccess, cbFailed) {
  getCities(country, city)
    .then(
      (cities) => {
        if (!cities.data.success) {
          cbFailed();
          return false;
        }

        cbSuccess({ city: cities.data?.data ?? [], country: country });
      },
      (error) => {
        console.error(error.toString());
        cbFailed();
      }
    )
    .catch((error) => {
      console.error(error.toString());
      cbFailed();
    });
}

/**
 * Request and set to redux active countries
 */
export const getActiveCountriesList = () => {
  return (dispatch) => {
    dispatch(toggleSendActiveCountries(true));
    getActiveCountries()
      .then(({ data }) => {
        if (!data.success) {
          return false;
        }
        dispatch(setActiveCountries(data?.data));
      })
      .catch((error) => {
        console.error(error.toString());
      })
      .finally(() => {
        dispatch(toggleSendActiveCountries(false));
      });
  };
};
